export default "__VITE_ASSET__jBzyVoKA__"